module.exports = __webpack_public_path__ + "media/images/icon_search_keyword-b9fec510cd6d448c93a05e54339ddfd7.png";